import * as React from 'react';
import { MAX_OFFERS_BEFORE_CAROUSEL } from 'shared/constants/newbuildingCarouselOffers';
import { NewbuildingOffersCarouselContainer } from 'shared/containers/NewbuildingOffersCarouselContainer';

import { BannerContainer } from '../../../serp/containers/Banner';
import { IIntegrateAdOptions } from '../types';

/**
 * Позиция смещения для показа карусели новостроек (после 2-го оффера)
 */
const NEWBUILDING_CAROUSEL_POSITION_OFFSET = 2;

export interface IGetCarouselBannerParams {
  positionOffset: number;
  position: number;
  index: number;
  offersLength: number;
  isNewbuildingOffersWithBannerCarouselVisible?: boolean;
  willCarouselBannerBeShown: boolean | undefined;
  suggestionFragment: IIntegrateAdOptions['suggestionFragment'];
  isAgent?: boolean;
  options: IIntegrateAdOptions;
  locationId?: number;
  isCountrysideBuildersBannerAvailable?: boolean;
}

/**
 * Определяет, нужно ли показывать карусель новостроек и в каком виде
 * @returns React элемент карусели или null
 */
export const getCarouselBanner = ({
  positionOffset,
  position,
  index,
  offersLength,
  isNewbuildingOffersWithBannerCarouselVisible,
  willCarouselBannerBeShown,
  suggestionFragment,
  isAgent,
  options,
  locationId,
  isCountrysideBuildersBannerAvailable,
}: IGetCarouselBannerParams): React.ReactNode | null => {
  // Показываем карусель с баннером КПН и фолбэком из баннеров на 3-й позиции (после 2-го оффера)
  // когда офферов >= 4
  const isCarouselBannerShown =
    positionOffset === NEWBUILDING_CAROUSEL_POSITION_OFFSET && Boolean(willCarouselBannerBeShown);

  if (isCarouselBannerShown) {
    return (
      <BannerContainer
        key={`banner_${position}`}
        isAgent={isAgent}
        options={options}
        position={position}
        locationId={locationId}
        isVisibleNewbuildingCarousel={true}
        isCountrysideBuildersBannerAvailable={isCountrysideBuildersBannerAvailable}
      />
    );
  }

  // Показываем карусель без фолбека в конце последней объявки
  // когда офферов < 4
  const shouldShowCarouselAtEnd =
    index === offersLength - 1 &&
    offersLength < MAX_OFFERS_BEFORE_CAROUSEL &&
    !suggestionFragment.isSimilar &&
    Boolean(isNewbuildingOffersWithBannerCarouselVisible);

  if (shouldShowCarouselAtEnd) {
    return <NewbuildingOffersCarouselContainer key="newbuilding-carousel-end" />;
  }

  return null;
};
